import { render, staticRenderFns } from "./ReiseDaten.vue?vue&type=template&id=536ba5b8&scoped=true"
import script from "./ReiseDaten.vue?vue&type=script&lang=ts"
export * from "./ReiseDaten.vue?vue&type=script&lang=ts"
import style0 from "./ReiseDaten.vue?vue&type=style&index=0&id=536ba5b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536ba5b8",
  null
  
)

export default component.exports